export default "__VITE_ASSET__577lOdLX__"